import { useState, createContext } from 'react';

const TicketsContext = createContext();

const TicketsContextProvider = ({ children }) => {
  const [currentTicket, setCurrentTicket] = useState({
    id: null,
    uuid: null,
    code: null,
  });
  const [tab, setTab] = useState('open');
  const [tabOpen, setTabOpen] = useState('pending');
  const [searchContact, setSearchContact] = useState('');

  return (
    <TicketsContext.Provider
      value={{
        currentTicket,
        setCurrentTicket,
        tab,
        setTab,
        tabOpen,
        setTabOpen,
        searchContact,
        setSearchContact,
      }}
    >
      {children}
    </TicketsContext.Provider>
  );
};

export { TicketsContext, TicketsContextProvider };
